module.exports = __webpack_public_path__ + "0aafbe5220dfba2128a1d5d8621f2c75.png";